import {apiLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../../../app/api/rp_api";
import {getIgnoredNotifyResponse} from "../../../../store/utils/get_ignored_notify_response";
import {FloorPreviewUrl} from "./fetch_building_planner_details";

interface Building {
    uuid: string;
    name: string;
    floor_preview_urls: FloorPreviewUrl[];
}

interface PlannerInvestmentData {
    uuid: string;
    name: string;
    is_ready: boolean;
    last_plan_update: string;
    floor_preview_urls: Building[];
}

const readClientApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getPlannerInvestmentData: build.query<PlannerInvestmentData, {investmentUuid: string}>({
            query: ({investmentUuid}) => ({
                url: apiLink.planner.investments.detail({})({investmentUuid})
            }),
            transformErrorResponse: (response) => {
                return getIgnoredNotifyResponse(response, [404]);
            }
        })
    })
});

export const {useGetPlannerInvestmentDataQuery} = readClientApi;
import {apiLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../../../app/api/rp_api";
import {getIgnoredNotifyResponse} from "../../../../store/utils/get_ignored_notify_response";
import {FloorPreviewUrl} from "./fetch_building_planner_details";

interface Building {
    uuid: string;
    name: string;
    floor_preview_urls: FloorPreviewUrl[];
}

interface PlannerInvestmentData {
    uuid: string;
    name: string;
    is_ready: boolean;
    last_plan_update: string;
    floor_preview_urls: Building[];
}

const readClientApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getPlannerInvestmentData: build.query<PlannerInvestmentData, {investmentUuid: string}>({
            query: ({investmentUuid}) => ({
                url: apiLink.planner.investments.detail({})({investmentUuid})
            }),
            transformErrorResponse: (response) => {
                return getIgnoredNotifyResponse(response, [404]);
            }
        })
    })
});

export const {useGetPlannerInvestmentDataQuery} = readClientApi;
